function includesCaseInsensitive(value, expected) {
  return typeof value === 'string' && value.toLowerCase().includes(expected.toLowerCase());
}

function numericValue(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function cardHasType(card, expected) {
  const types = Array.isArray(card?.types) && card.types.length ? card.types : [card?.type];
  return types.some((type) => String(type || '').toLowerCase() === String(expected || '').toLowerCase());
}

function sortValue(card, sortBy) {
  if (sortBy === 'id') return card?.riftbound_id || card?.api_id || card?.id || '';
  if (sortBy === 'name') return card?.name || '';
  return numericValue(card?.[sortBy]);
}

export function filterAndSortCards(cards, filters) {
  const source = Array.isArray(cards) ? cards : [];
  const {
    searchTerm,
    selectedDomains,
    selectedRarities,
    selectedType,
    selectedSet,
    selectedSupertype,
    selectedVariant,
    sortBy,
    sortOrder,
    energyRange,
    powerRange,
    mightRange,
  } = filters;

  const result = source.filter((card) => {
    if (searchTerm && !includesCaseInsensitive(card?.name, searchTerm)) return false;

    const domains = Array.isArray(card?.domains) ? card.domains : [];
    if (selectedDomains.length > 0 && !selectedDomains.some((domain) => domains.includes(domain))) {
      return false;
    }
    if (selectedType !== 'All' && !cardHasType(card, selectedType)) return false;
    if (
      selectedRarities.length > 0
      && !selectedRarities.some((rarity) => card?.rarity?.toLowerCase() === rarity.toLowerCase())
    ) {
      return false;
    }
    if (selectedSet !== 'All' && card?.set_label !== selectedSet) return false;
    if (
      selectedSupertype !== 'All'
      && card?.supertype?.toLowerCase() !== selectedSupertype.toLowerCase()
    ) {
      return false;
    }
    if (selectedVariant !== 'All') {
      const variant = selectedVariant.toLowerCase();
      const tags = Array.isArray(card?.tags) ? card.tags : [];
      const matchesVariant = tags.some((tag) => includesCaseInsensitive(tag, variant))
        || (card?.alternate_art && variant === 'alternate')
        || (card?.signature && variant === 'signature')
        || (card?.overnumbered && variant === 'token');
      if (!matchesVariant) return false;
    }

    const energy = numericValue(card?.energy);
    const power = numericValue(card?.power);
    const might = numericValue(card?.might);
    return energy >= energyRange[0] && energy <= energyRange[1]
      && power >= powerRange[0] && power <= powerRange[1]
      && might >= mightRange[0] && might <= mightRange[1];
  });

  return result.sort((cardA, cardB) => {
    const valueA = sortValue(cardA, sortBy);
    const valueB = sortValue(cardB, sortBy);
    const comparison = typeof valueA === 'string'
      ? valueA.localeCompare(valueB)
      : valueA - valueB;
    return sortOrder === 'desc' ? -comparison : comparison;
  });
}
